export {default} from './CoachesToCelebrateSection.connect';
